/**
 * @Date: 2020-06-15 11:42
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import Main from '@/components/Layout/Layout'
import SubMain from '@/views/Main'

export default {
  sort: 5,
  routers: [
    {
      path: '/Channel',
      name: 'channel',
      component: Main,
      meta: {
        isHideInMenu: false,
        isCache: false,
        icon: 'alert',
        title: '渠道管理'
      },
      redirect: '/Channel/Channel/Attributes',
      children: [
        {
          path: '/Channel/Channel',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '渠道管理'
          },
          redirect: '/Channel/Channel/Attributes',
          children: [
            {
              path: '/Channel/Channel/Attributes',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '渠道属性'
              },
              component: () => import('@/views/Channel/Channel/Attributes/Attributes.vue')
            },
            {
              path: '/Channel/Channel/Account',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '渠道账户'
              },
              component: () => import('@/views/Channel/Channel/Account/Account.vue')
            }
          ]
        }
      ]
    }
  ]
}
